"use client"

import CampaignSubscriberUpsertForm from "@/(admin)/modules/campaign-subscribers/pages/CampaignSubscriberUpsertForm_temp"
import { FormSection, FormShell, FormSkeleton, StickyActionBar } from "@/(admin)/components/form"
import AccessDenied from "@/components/custom-access-denied"
import { CAMPAIGN_SUBSCRIBERS } from "@/constants/admin-paths"
import { useCheckPermission } from "@/hook/use-check-permission"
import { t } from "@/languages/i18n"
import { SaveOutlined } from "@ant-design/icons"
import { Button } from "antd"
import { useUpsertCampaignSubscribers } from "../hooks/useUpsertCampaignSubscribers"

const UpsertCampaignSubscriber = () => {
  const { form, isEditMode, loading, submitting, campaignOptions, isButtonDisabled, handlers } =
    useUpsertCampaignSubscribers()

  const { hasPermission: checkPermission } = useCheckPermission()

  const requiredPermission = isEditMode ? "update" : "create"

  if (!checkPermission("campaign-subscriber", requiredPermission)) {
    return <AccessDenied />
  }

  if (loading && isEditMode) {
    return <FormSkeleton mainSections={2} sidebarCards={0} />
  }

  const crumbs = [
    { title: t("Đăng ký chiến dịch"), href: `/admin${CAMPAIGN_SUBSCRIBERS.LIST.PATH}` },
    { title: isEditMode ? t("Chỉnh sửa") : t("Tạo mới") },
  ]

  const main = (
    <FormSection title={t("Thông tin đăng ký")} collapsible={false}>
      <CampaignSubscriberUpsertForm
        form={form}
        campaignOptions={campaignOptions}
        onFormChange={handlers.handleFormChange}
      />
    </FormSection>
  )

  const actionBar = (
    <StickyActionBar
      right={
        <>
          <Button onClick={handlers.handleBack}>{t("Cancel")}</Button>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            loading={submitting}
            disabled={isButtonDisabled}
            onClick={handlers.handleSubmit}
          >
            {isEditMode ? t("Update") : t("Create")}
          </Button>
        </>
      }
    />
  )

  return (
    <FormShell
      title={isEditMode ? t("Edit Campaign Subscriber") : t("Add Campaign Subscriber")}
      crumbs={crumbs}
      main={main}
      actionBar={actionBar}
    />
  )
}

export default UpsertCampaignSubscriber
